import {
  NormalBrowseFileInputFiled,
  NormalMultipleFixedInputFields,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const MediaCenterPageCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {/* Common Section Form Fields */}
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Common Banner Image"
              fieldId="media-center-common-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("media-center-common-banner-image", id)
                  : handleImageChange("media-center-common-banner-image", "")
              }
              selectedFileId={
                formData?.["media-center-common-banner-image"] || ""
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Common Banner Heading"
            fieldId="media-center-common-banner-heading"
            fieldName="media-center-common-banner-heading"
            placeholderText="Heading"
            inputValue={formData?.["media-center-common-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Common Banner Description"
            fieldId="media-center-common-banner-heading"
            fieldName="media-center-common-banner-description"
            placeholderText="Description"
            inputValue={
              formData?.["media-center-common-banner-description"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Tabs */}
          <NormalMultipleFixedInputFields
            stateDetails={formData}
            isFetching={isFetching}
            labelText="Main Tabs"
            fieldId="media-center-common-tabs"
            handleTextInputChange={handleTextInputChange}
            // handleTextEditorInputChange={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
            cards={[
              {
                card_id: "media-center-tab-card-1",
                types: ["TEXT", "TEXT", "TEXT", "TEXT"],
                is_hidden: [true, true, true, true],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                  "text_filed_id_4",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                  "text_filed_placeholder_4",
                ],
                // IDs
                text_filed_id_1: "media-center-tab-label-1",
                text_filed_id_2: "media-center-tab-label-2",
                text_filed_id_3: "media-center-tab-label-3",
                text_filed_id_4: "media-center-tab-label-4",
                // Placeholders
                text_filed_placeholder_1: "Tab Name 1",
                text_filed_placeholder_2: "Tab Name 2",
                text_filed_placeholder_3: "Tab Name 3",
                text_filed_placeholder_4: "Tab Name 4",
              },
            ]}
          />
        </>
      )}
    </>
  );
};

export default MediaCenterPageCMSForm;
